import { WidgetInstance } from 'friendly-challenge';
import Events from "./Events";
import Meta from "./Meta";

class ContactForm {
  static SITE_KEY = 'FCMHKULDAKNN75SD';

  sending;
  notificationTimeout;
  notificationDiv;
  widgets = [];

  constructor() {
    this.sending = 0;
    this.notificationDiv = document.createElement('div');

    this.setupWidgets();
  }

  setupWidgets() {
    const elements = document.querySelectorAll('.captcha-widget');

    for (const element of [].slice.call(elements)) {
      const options = {
        sitekey: ContactForm.SITE_KEY
      }
      this.widgets.push(new WidgetInstance(element, options))
    }

    this.setListeners();
  }

  setListeners() {
    const form = document.querySelector('#quote form');
    if (form) {
      form.addEventListener(Events.SUBMIT, this.sendForm.bind(this));
    }
  }

  sendForm(e) {
    e.preventDefault();
    const form = e.currentTarget;

    const solution = document.querySelector('.frc-captcha-solution').value;
    if (solution.length <= 0) {
      this.notify('Please complete the captcha.');
      return;
    }

    if (this.sending) return;

    var error = null;
    var inputs = form.querySelectorAll("input, select, textarea");

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.length <= 0) {
        error = "Please enter your " + inputs[i].name.replace(/\-/g, ' ').toLowerCase();
        break;
      }
    }

    if (error !== null) {
      this.notify(error);
      return;
    }

    this.sending = 1;

    const formData = new FormData(form);

    fetch("/php/routes/contact.php", {
      method: "POST",
      body: formData
    })
      .then(
        (response) => response.text(),
        (error) => { this.sending = 0; this.notify("Something went wrong, please try again."); })
      .then(response => {
          this.sending = 0;
          if (response === "fail") {
            this.notify( "Our spam filter system thinks you might be a robot. If you think that this is in error, please refresh the page and try again.");
            return;
          }
          form.reset();

          for (const widget of this.widgets) {
            widget.reset();
          }

          this.notify("Thank you for your message, we'll be in touch soon", true);

          // Track Lead conversion for Meta Pixel
          Meta.trackLead();
        }
      )
      .catch(
        (error) => {
          this.sending = 0;
          this.notify("Something went wrong, please try again.");
        }
      )
  }

  notify(message, success) {
    clearTimeout(this.notificationTimeout);
    if (!document.body.contains(this.notificationDiv)) {
      this.notificationDiv = document.createElement('div');
      this.notificationDiv.className = 'form-notify';
      document.body.appendChild(this.notificationDiv);
    }
    if(success === true) {
      this.notificationDiv.id = 'tagContactID';
    }

    this.notificationDiv.innerHTML = '<p>' + message + '</p>';

    this.notificationTimeout = setTimeout(() => {
      document.body.removeChild(this.notificationDiv);
      this.notificationDiv.innerHTML = '';
    }, 5000);
  }
}

const contactForm = new ContactForm();
export default contactForm;
